import Convert from "utils/convert"
import APIs from "redux/apis"
import chartConfig from "./chartConfig"
import { UserStorage } from "utils/userStorage"
import _ from "lodash"

interface Window {
  Logic: any
}

declare var window: Window

export async function setChartSession() {
  if (_.isEmpty(UserStorage.ChartSession.get())) {
    const chartSession = await APIs.Chart.GetChartSession()
    UserStorage.ChartSession.set(chartSession)
  }
  const data = UserStorage.ChartSession.get()
  chartConfig.ChartSessions = setChartSessionConfig(data)
}

export function setChartSessionConfig(data?: any) {
  try {
    let chartSession: any = {}
    _.forEach(data, x => {
      let key = x.SecurityType.toString() + "@" + x.Exchange.toString()

      chartSession[key] = _.map(x["Times"], y => {
        let hms = ""
        // 2019/02/01 Exchange: 300 , SecurityType: 30で、"ChartTimes": nullとなっているので注意
        if (
          y["ChartTimes"] &&
          y["ChartTimes"][0] &&
          y["ChartTimes"][0]["ChartStartTime"]
        ) {
          let h = y["ChartTimes"][0]["ChartStartTime"].substr(0, 2)
          let m = y["ChartTimes"][0]["ChartStartTime"].substr(2, 2)
          let s = y["ChartTimes"][0]["ChartStartTime"].substr(4, 2)
          hms = " " + h + ":" + m + ":" + s
        }
        let from = Date.parse(
          Convert.date(parseInt(y["ApplyFrom"], 10), "yyyy/MM/dd") + hms
        )

        let time_map = _.map(y["ChartTimes"], z => {
          let sh = parseInt(z["ChartStartTime"].substr(0, 2), 10)
          let sm = parseInt(z["ChartStartTime"].substr(2, 2), 10)
          let eh = parseInt(z["ChartEndTime"].substr(0, 2), 10)
          let em = parseInt(z["ChartEndTime"].substr(2, 2), 10)
          let diff =
            sh * 100 + sm < eh * 100 + em
              ? eh * 60 + em - (sh * 60 + sm)
              : (eh + 24) * 60 + em - (sh * 60 + sm)
          return window.Logic.Helper.toSession(sh, sm, diff)
        })
        return [from, time_map]
      })
    })
    return chartSession
  } catch (e) {
    console.log(e)
    return {}
  }
}

export const getChartSession = () => {
  return !_.isEmpty(chartConfig.ChartSessions)
    ? chartConfig.ChartSessions
    : setChartSessionConfig(UserStorage.ChartSession.get())
}
